import { resetAppState } from '@/app/appReset';

const APP_VERSION_KEY = 'app_version';

// Shared by the startup check and the live poll (versionPoll.ts). Forces a
// full app reset so stale tokens/state don't survive into the new version,
// then writes the target version before reloading to prevent a reload loop.
//
// The logout endpoint is intentionally skipped — dropping tokens locally is
// sufficient to redirect the user to login on the next render.
function forceVersionTransition(targetVersion: string): void {
	resetAppState();
	localStorage.setItem(APP_VERSION_KEY, targetVersion);
	window.location.reload();
}

/**
 * Runs once at app startup (before React renders).
 *
 * All static imports in main.tsx are hoisted and executed before any
 * top-level code runs, so the session/Zustand stores will have already
 * hydrated from localStorage by the time this function is called.
 */
export function runVersionGuard(): void {
	const currentVersion = __APP_VERSION__;
	const storedVersion = localStorage.getItem(APP_VERSION_KEY);

	if (storedVersion === currentVersion) return;

	forceVersionTransition(currentVersion);
}

// Called by versionPoll.ts when it detects a deployed version that differs
// from the one currently running in this tab.
export function forceVersionReload(liveVersion: string): void {
	forceVersionTransition(liveVersion);
}
